/*
  用于设备控制时的数据传递
 */
import types from "../../types"

const state = {
  // 当前设备数据
  device_data: "",
  // 当前教室数据
  classroom_data: "",
};

const getters = {};

const actions = {
  // 教室数据变化
  classroom_data_change({commit, state}, val) {
    commit(types.CLASSROOM_DATA_CHANGE, val);
  },

  // 设备数据变化
  device_data_change({commit, state}, val) {
    commit(types.DEVICE_DATA_CHANGE, val);
  },
};

const mutations = {
  // 教室数据变化
  [types.CLASSROOM_DATA_CHANGE](state, val) {
    state.classroom_data = val;
  },

  // 设备数据变化
  [types.DEVICE_DATA_CHANGE](state, val) {
    state.device_data = val;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/control/common.js